import React from "react";
import { connect } from "react-redux";
import { Row, Col } from "react-bootstrap";
import { slideInRight } from "react-animations";
import Radium, { StyleRoot } from "radium";
import ReactMapGL, { Marker, Popup } from "react-map-gl";
import Explore from "../MainPage/Explore";
import Testimonials from "../MainPage/Testimonials";
import AppConfig from "../../config";
import "../MainPage/MainPageStyle.scss";
import "./Services.scss";

const API_URL = AppConfig.API_URL;

class Services extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  getText = (text) => {
    const { loadTranslations, currentLanguage } = this.props;
    return loadTranslations(text, currentLanguage);
  };

  render() {
    const styles = {
      slideInRight: {
        animation: "x .5s",
        animationName: Radium.keyframes(slideInRight, "slideInRight"),
      },
      slideInRight2: {
        animation: "x 1s",
        animationName: Radium.keyframes(slideInRight, "slideInRight"),
      },
      slideInRight3: {
        animation: "x 1.5s",
        animationName: Radium.keyframes(slideInRight, "slideInRight"),
      },
      slideInRight4: {
        animation: "x 2s",
        animationName: Radium.keyframes(slideInRight, "slideInRight"),
      },
      slideInRight5: {
        animation: "x 2.3s",
        animationName: Radium.keyframes(slideInRight, "slideInRight"),
      },
    };
    return (
      <div className="services-wrap">
        <section
          className="services-banner section-gap-full relative"
          data-stellar-background-ratio="0.5"
          style={{ padding: "80px 0 20px", background: "#f7f8f9" }}
        >
          <div className="pix-item-review">
            <Row>
              <Col lg={12} md={12} sm={12} xs={12} className="no-padding margin-bottom">
                <Row>
                  <Col lg={4} md={4} sm={6} xs={12} className="pix-item-1">
                    <Row>
                      <Col
                        lg={2}
                        md={2}
                        sm={2}
                        xs={2}
                        className="no-padding transparent pix-icon-l pix-icon-color text-center"
                      >
                        {/* <i className="flaticon-shield"></i> */}
                        <i className="fas fa-stethoscope" />
                      </Col>
                      <Col lg={10} md={10} sm={10} xs={10}>
                        <h6>Persönlicher Ansprechpartner</h6>
                        <p  style={{ textAlign:"justify", textJustify:"inter-word" }}> 
                          In unserer Gruppenpraxis werden Sie von Ihrer
                          gewählten Ansprechperson - ihrer Hausärztin oder ihrem
                          Hausarzt - betreut. Diese kennt Sie und kann gemeinsam
                          mit Ihnen die sowohl geeignetste wie auch
                          effizienteste und kostenbewussteste Behandlung
                          bestimmen. Bei Abwesenheit Ihrer persönlichen
                          Ansprechperson stehen die Praxiskolleg*innen
                          stellvertretend zur Verfügung.
                        </p>
                      </Col>
                    </Row>
                  </Col>
                  <Col lg={4} md={4} sm={6} xs={12} className="pix-item-2">
                    <Row>
                      <Col
                        lg={2}
                        md={2}
                        sm={2}
                        xs={2}
                        className="no-padding transparent pix-icon-l pix-icon-color text-center"
                      >
                        <i class="fas fa-shield-alt" />
                      </Col>
                      <Col lg={10} md={10} sm={10} xs={10}>
                        <h6>Gelebte Qualitätskultur</h6>
                        <p  style={{ textAlign:"justify", textJustify:"inter-word" }}> 
                          Wir sind in unserer medizinischen Tätigkeit der
                          Qualitätssicherung verpflichtet. Der interkollegiale
                          Austausch in Form von Qualitätszirkeln und
                          Intervisionen, das Beachten fachspezifischer
                          Leitlinien, das regelmässige Besuchen von
                          Fortbildungen sowie das Betreiben eines
                          CIRS-Meldesystems für kritische Zwischenfälle in der
                          Praxis sorgen für ein systematisches Qualitätsdenken.
                        </p>
                      </Col>
                    </Row>
                    </Col>
                  <Col lg={4} md={4} sm={6} xs={12} className="pix-item-3">
                    <Row>
                      <Col
                        lg={2}
                        md={2}
                        sm={2}
                        xs={2}
                        className="no-padding transparent pix-icon-l pix-icon-color text-center"
                      >
                        <i className="far fa-gem" />
                      </Col>
                      <Col lg={10} md={10} sm={10} xs={10}>
                        <h6>Moderne Ausrüstung</h6>
                        <p  style={{ textAlign:"justify", textJustify:"inter-word" }}> 
                        In unserer Praxis steht uns eine moderne technische Ausrüstung zur Verfügung. Dazu gehören beispielsweise die vollelektronische 
                        Kranken- geschichte, das digitale Röntgen und das umfangreiche Praxislabor. Damit können wir die meisten Abklärungen auf höchstmöglichem 
                        Niveau und ohne grössere Wartezeiten direkt im Hause vornehmen.
                        </p>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
              <Col lg={12} md={12} sm={12} xs={12} className="no-padding">
                <Row>
                  <Col lg={4} md={4} sm={6} xs={12} className="pix-item-4">
                    <Row>
                      <Col
                        lg={2}
                        md={2}
                        sm={2}
                        xs={2}
                        className="no-padding transparent pix-icon-l pix-icon-color text-center"
                      >
                        <i className="fas fa-calendar-alt" />
                      </Col>
                      <Col lg={10} md={10} sm={10} xs={10}>
                        <h6>Breites Angebot</h6>
                        <p  style={{ textAlign:"justify", textJustify:"inter-word" }}> 
                          Eine integrierte Physiotherapie und weitere
                          medizinische Leistungen, wie eine Venensprechstunde,
                          eine Ernährungs- sowie Diabetesberatung, ergänzen die
                          hausärztliche Grundversorgung vor Ort und sorgen für
                          ein breites Angebot und eine Vernetzung der
                          Fachpersonen.
                        </p>
                      </Col>
                    </Row>
                  </Col>
                  <Col lg={4} md={4} sm={6} xs={12} className="pix-item-5">
                    <Row>
                      <Col
                        lg={2}
                        md={2}
                        sm={2}
                        xs={2}
                        className="no-padding transparent pix-icon-l pix-icon-color text-center "
                      >
                        <i className="fas fa-heartbeat"></i>
                      </Col>
                      <Col lg={10} md={10} sm={10} xs={10}>
                        <h6>Hausarztmodell</h6>
                        <p  style={{ textAlign:"justify", textJustify:"inter-word" }}> 
                          Wir bieten unsere Leistungen auch im Hausarztmodell an.
                          Somit sind wir die erste Anlaufstelle für all Ihre
                          Gesundheitsfragen, koordinieren Ihre Behandlungen und
                          überweisen Sie, wenn nötig, an Spitäler und
                          Spezialisten aus unserem Netzwerk. 
                        </p>
                      </Col>
                    </Row>
                  </Col>
                  <Col lg={4} md={4} sm={6} xs={12} className="pix-item-6">
                    <Row>
                      <Col
                        lg={2}
                        md={2}
                        sm={2}
                        xs={2}
                        className="no-padding transparent pix-icon-l pix-icon-color text-center"
                      >
                        <i className="fas fa-bolt" />
                      </Col>
                      <Col lg={10} md={10} sm={10} xs={10}>
                        <h6>Hochqualitative medizinische Betreuung</h6>
                        <p  style={{ textAlign:"justify", textJustify:"inter-word" }}> 
                        Wir streben eine zielgerichtete, qualitativ hochstehende und kostenbewusste Betreuung im Sinne einer partnerschaftlichen, hausärztlich koordinierten Medizin an. Unseren Patient*innen begegnen wir mit Empathie und hoher fachlicher Kompetenz.
                        </p>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
        </section>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    currentLanguage: state.users.currentLanguage,
  };
}

export default connect(mapStateToProps)(Services);



// WEBPACK FOOTER //
// ./screens/Services/Services.js